/** What the session-name refresh reads from Coordinator's whoami. */
export type WhoAmINames = {
  account_id: string;
  full_name?: string;
  preferred_name?: string | null;
};

/**
 * Copies the account's current display name onto the dashboard session after
 * the operator edits their profile on account settings. Any failure leaves the
 * session as it was, so the caller can still navigate on.
 */
export async function refreshSessionName({
  session,
  fetchWhoAmI,
  updateUser,
  invalidateSession,
}: {
  session: { accountId: string; name: string };
  fetchWhoAmI: () => Promise<WhoAmINames>;
  updateUser: (name: string) => Promise<{ error: unknown }>;
  invalidateSession: () => Promise<void>;
}): Promise<void> {
  try {
    const whoAmI = await fetchWhoAmI();
    if (whoAmI.account_id !== session.accountId) {
      return;
    }
    const name =
      whoAmI.preferred_name?.trim() || whoAmI.full_name?.trim() || "";
    if (!name || name === session.name) {
      return;
    }
    const { error } = await updateUser(name);
    if (error) {
      return;
    }
    await invalidateSession();
  } catch {
    // The refresh is best effort; the next sign-in syncs the name anyway.
  }
}
